import type {
  CreateTesterTargetRequest,
  RunMassNotificationTestRequest,
  TesterRunResult,
  TesterRunsList,
  TesterTarget,
  TesterTargetCheckResult,
  TesterTargetsList,
  UpdateTesterTargetRequest,
} from "@xop/dashboard-shared";

import { api } from "../../lib/api.js";

/** Thin typed client for the Tester server API (`/api/tester/*`). */
export const testerApi = {
  listTargets: () => api<TesterTargetsList>("/api/tester/targets"),

  createTarget: (body: CreateTesterTargetRequest) =>
    api<TesterTarget>("/api/tester/targets", { method: "POST", body }),

  updateTarget: (id: number, body: UpdateTesterTargetRequest) =>
    api<TesterTarget>(`/api/tester/targets/${id}`, { method: "PATCH", body }),

  deleteTarget: (id: number) =>
    api<void>(`/api/tester/targets/${id}`, { method: "DELETE" }),

  checkTarget: (id: number) =>
    api<TesterTargetCheckResult>(`/api/tester/targets/${id}/check`, {
      method: "POST",
    }),

  listRuns: () => api<TesterRunsList>("/api/tester/runs"),

  run: (body: RunMassNotificationTestRequest) =>
    api<TesterRunResult>("/api/tester/run", { method: "POST", body }),
};
